<template>
<!-- 插件 -->
<el-dialog title="新增/编辑" :visible.sync="fromVisible" :before-close="handleClose" @opened="openFrom()">
    <el-form :model="formData" :rules="rules" ref="ruleForm">
      <el-form-item label="手机号" :label-width="formLabelWidth" prop="mobile_phone" style="margin-bottom: 17px">
        <el-input v-model="formData.mobile_phone" :disabled="mobile_dis" autocomplete="off" placeholder="请输入用户手机号"></el-input>
      </el-form-item>
      <el-form-item label="角色编码" :label-width="formLabelWidth" prop="role_code" style="margin-bottom: 17px">
        <el-input v-model="formData.role_code"  autocomplete="off" placeholder="请输入角色编码"></el-input>
      </el-form-item>
      <el-form-item label="绑定角色" :label-width="formLabelWidth" prop="role_id" style="margin-bottom: 17px">
        <el-select v-model="formData.role_id" placeholder="请选择">
            <el-option
              v-for="item in role_list"
              :key="item.id"
              :label="item.role_name"
              :value="item.id">
            </el-option>
          </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose()">取 消</el-button>
      <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
    </div>
</el-dialog>
</template>
<script>
    export default {
        name:"fromUser",
        props:{
            fromVisible:Boolean,   
            user_id:Number,   
        },
        data(){
            return {
                mobile_dis:false,
                formData:{ },//数据
                formLabelWidth: '120px', //表单宽度 
                role_list:[], //角色选项
                rules: { //验证规则 
                    mobile_phone: [
                        {required: true, message: '请输入手机号', trigger: 'blur'},
                    ],
                    role_code: [
                        {required: true, message: '请输入角色编码', trigger: 'blur'},
                    ],
                    role_id: [
                        {required: true, message: '请选择角色id', trigger: 'change'},
                    ]
                },
            }
        },
        created() {
            this.selRole();
            if(this.user_id == 0){
                this.mobile_dis = false;
            }else{
                this.mobile_dis = true;
                this.findAdmin(this.user_id);
            }
        },
        methods: {
            //关闭弹窗 
            handleClose() {
                this.$emit('getData');
                this.$emit('handleFromVisible',false);
            },
            //角色列表 
            selRole() {
                this.loading = true;
                this.$api.post("/api/role/getRoleList", [], res => {
                    if (res.status == 200) {
                        this.role_list = res.data;
                    } else {
                    this.$message.error(res.msg);
                    }
                    //渲染结束后取消加载
                    this.loading = false;
                })
            },
             // 添加表单校验
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                    // 添加确定
                        this.$api.post('/api/role/bindUserRole', this.formData, res => {
                            if (res.status == 200) {
                            this.$message({
                                type: 'success',
                                message: '操作成功',
                                duration: 1000,
                            });
                            this.handleClose();
                            } else {
                                this.$message.error(res.msg);
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
            //查询 
            findAdmin(user_id){
                this.$api.post("/api/role/findAdmin", {user_id}, res => {
                    if(res.status == 200){
                        const data = res.data;
                        this.formData= data;
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },
            //清除数据 
            clearData(){
                this.formData = [];
                this.checked_keys = [];
                this.expanded_keys = [];
            }
        }
    }
</script>
<style scoped>
    .menu_tree{
        margin-top:10px;
    }
</style>
